import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Keyboard, Platform, ScrollView, StyleSheet, View } from 'react-native';
import { SafeAreaInsetsContext } from 'react-native-safe-area-context';

import Layout from '../constants/Layout';

function MyScrollView(props) {
  const { children, containerStyle, contentContainerStyle, compressHeight, testID } = props;
  const mounted = useRef(false); // to prevent Can't perform a React state ... error
  const [keyboardShown, setKeyboardShown] = useState(false);
  const [keyboardHeight, setKeyboardHeight] = useState(0);
  const [fullHeight, setFullHeight] = useState(Layout.fullHeight);
  const [scroll, setScroll] = useState(null);

  const keyboardDidShow = (e) => {
    const height = e.endCoordinates.height;
    if (mounted.current) {
      setKeyboardShown(true);
      setKeyboardHeight(height);

      setTimeout(() => {
        if (scroll && typeof scroll.scrollToEnd == 'function') {
          scroll.scrollToEnd({ animated: true });
        }
      }, 100);
    }
  };

  const keyboardDidHide = () => {
    if (mounted.current) {
      setKeyboardShown(false);
      if (scroll && typeof scroll.scrollTo == 'function') {
        scroll.scrollTo({ x: 0, y: 0, animated: true });
      }
    }
  };

  const keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', keyboardDidShow);

  const keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', keyboardDidHide);

  useEffect(() => {
    mounted.current = true;
    return () => {
      keyboardDidShowListener.remove();
      keyboardDidHideListener.remove();
      mounted.current = false;
    };
  }, []);

  const container = containerStyle ? [containerStyle, styles.container] : styles.container;
  const contentContainer = contentContainerStyle
    ? [contentContainerStyle, styles.contentContainer]
    : styles.contentContainer;

  const minHeight =
    (Platform.OS === 'android' ? fullHeight : keyboardShown ? fullHeight + keyboardHeight : fullHeight) *
    (compressHeight || 1);
  return (
    <SafeAreaInsetsContext.Consumer>
      {(insets) => (
        <ScrollView
          keyboardShouldPersistTaps="handled"
          ref={(c) => setScroll(c)}
          contentContainerStyle={[contentContainer, { minHeight }]}
          style={[container, { paddingTop: insets.top }]}
          testID={testID || 'scroll-view'}
        >
          {children}
          <View
            style={{
              height: keyboardShown && Platform.OS !== 'android' ? keyboardHeight : 0,
            }}
          />
        </ScrollView>
      )}
    </SafeAreaInsetsContext.Consumer>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    flexGrow: 1,
  },
});

MyScrollView.propTypes = {
  testID: PropTypes.string,
  compressHeight: PropTypes.number,
  containerStyle: PropTypes.any, // createStylesheet is number but works as object
  contentContainerStyle: PropTypes.any,
};

export default MyScrollView;
